import React from 'react'
import { generatePublicUrl } from '../../urlConfig'
import { useDispatch } from 'react-redux'
import { updateCategoryVisiblePriceById } from '../../actions'
import { updateCategoryVisibleById } from './../../actions/category.action'
import Modal from '../UI/Modal'

const RenderSettingCategoryModal = ({
    setShowSettingCategoryModal,
    setCheckedCategoryVisible,
    showSettingCategoryModal,
    checkedCategoryVisible,
    loadingCategory,
    categoryObj,
    setChecked,
    checked,
}) => {
    const dispatch = useDispatch()

    if (!categoryObj) {
        return null
    }

    const closeModal = () => {
        if (loadingCategory) return
        setShowSettingCategoryModal(false)
    }

    const handlePricesVisibility = () => {
        if (loadingCategory) return

        dispatch(
            updateCategoryVisiblePriceById(
                categoryObj._id,
                categoryObj.slug
            )
        )

        setChecked(!checked)
    }

    const handleCategoryVisibility = () => {
        if (loadingCategory) return

        dispatch(updateCategoryVisibleById(categoryObj._id))
        setCheckedCategoryVisible(!checkedCategoryVisible)
    }

    const renderStatus = (visible) => (
        <span
            className={[
                'renderSettingCategoryModal__status',
                visible
                    ? 'renderSettingCategoryModal__status--visible'
                    : 'renderSettingCategoryModal__status--hidden',
            ].join(' ')}
        >
            {visible ? 'Показывается' : 'Скрыто'}
        </span>
    )

    return (
        <Modal
            show={showSettingCategoryModal}
            handleClose={closeModal}
            modalTitle={`Отображение категории «${categoryObj.name}»`}
            size="md"
            hideFooter
            preventOutsideClose={Boolean(loadingCategory)}
        >
            <div className="renderSettingCategoryModal">
                <p className="renderSettingCategoryModal__intro">
                    Эти настройки сразу влияют на то, что покупатель видит в каталоге.
                </p>

                <section className="renderSettingCategoryModal__setting">
                    <div className="renderSettingCategoryModal__settingMain">
                        <div className="renderSettingCategoryModal__settingTitle">
                            <strong>Цены товаров</strong>
                            {renderStatus(Boolean(checked))}
                        </div>

                        <span>
                            Показывать цены всех товаров этой категории покупателям.
                        </span>
                    </div>

                    <button
                        type="button"
                        className={
                            checked
                                ? 'renderSettingCategoryModal__action renderSettingCategoryModal__action--hide'
                                : 'renderSettingCategoryModal__action renderSettingCategoryModal__action--show'
                        }
                        onClick={handlePricesVisibility}
                        disabled={loadingCategory}
                    >
                        {checked ? 'Скрыть цены' : 'Показать цены'}
                    </button>
                </section>

                <section className="renderSettingCategoryModal__setting">
                    <div className="renderSettingCategoryModal__settingMain">
                        <div className="renderSettingCategoryModal__settingTitle">
                            <strong>Категория в каталоге</strong>
                            {renderStatus(Boolean(checkedCategoryVisible))}
                        </div>

                        <span>
                            Показывать саму категорию покупателям в публичном каталоге.
                        </span>
                    </div>

                    <button
                        type="button"
                        className={
                            checkedCategoryVisible
                                ? 'renderSettingCategoryModal__action renderSettingCategoryModal__action--hide'
                                : 'renderSettingCategoryModal__action renderSettingCategoryModal__action--show'
                        }
                        onClick={handleCategoryVisibility}
                        disabled={loadingCategory}
                    >
                        {checkedCategoryVisible ? 'Скрыть категорию' : 'Показать категорию'}
                    </button>
                </section>

                <section className="renderSettingCategoryModal__media">
                    <div className="renderSettingCategoryModal__mediaHead">
                        <div>
                            <strong>Изображение категории</strong>
                            <span>Текущее изображение, используемое в каталоге.</span>
                        </div>
                    </div>

                    <div className="renderSettingCategoryModal__preview">
                        {categoryObj.categoryImage ? (
                            <img
                                src={generatePublicUrl(categoryObj.categoryImage)}
                                alt={categoryObj.name || 'Категория'}
                            />
                        ) : (
                            <div className="renderSettingCategoryModal__previewEmpty">
                                Изображение не загружено
                            </div>
                        )}
                    </div>
                </section>

                <div className="renderSettingCategoryModal__footer">
                    <span>
                        {loadingCategory
                            ? 'Сохраняю изменение…'
                            : 'Изменения применяются сразу.'}
                    </span>

                    <button
                        type="button"
                        className="renderSettingCategoryModal__close"
                        onClick={closeModal}
                        disabled={loadingCategory}
                    >
                        Закрыть
                    </button>
                </div>
            </div>
        </Modal>
    )
}

export default RenderSettingCategoryModal
